export const pageTitle = 'お客さま情報の入力｜保険相談サービスお申し込みフォーム｜メットライフ生命'
export const confirmPageTitle = 'お客さま情報の確認｜保険相談サービスお申し込みフォーム｜メットライフ生命'
export const completePageTitle = 'お客さま情報の完了｜保険相談サービスお申し込みフォーム｜メットライフ生命'

export const consultKanjiName = 'お名前 [全角]'
export const consultKanjiLastName = '姓'
export const consultKanjiFirstName = '名'
export const consultKanaName = 'フリガナ [全角]'
export const consultKanaLastName = 'セイ'
export const consultKanaFirstName = 'メイ'
export const consultKanjiLastNamePlaceHolder = '生保'
export const consultKanjiFirstNamePlaceHolder = '太郎'
export const consultKanaLastNamePlaceHolder = 'セイホ'
export const consultKanaFirstNamePlaceHolder = 'タロウ'
export const consultBirthdate = '生年月日'
export const consultYear = '年'
export const consultMonth = '月'
export const consultDay = '日'
export const consultGender = '性別'
export const consultGenderMale = '男性'
export const consultGenderFemale = '女性'
export const consultZipcode = '郵便番号'
export const consultZipcodePlaceholder1 = '0123456'
export const consultZipcodePlaceholder2 = '4567'
export const consultTelephoneNumber = '電話番号'
export const consultTelephoneNumberPlaceholder1 = '0123456789'
export const consultTelephoneNumberPlaceholder2 = '1234'
export const consultTelephoneNumberPlaceholder3 = '5678'
export const consultEmailAddress = 'メールアドレス'
export const consultEmailAddressPlaceholder = 'abcde@abc.ne.jp'
export const consultContractStatus = '当社の契約状況'
export const consultContractStatusContracted = '契約あり'
export const consultContractStatusNoContract = '契約なし'
export const DetailsOfConsultation = 'ご相談内容（複数選択可）'
export const deathBenefit = '万一の死亡保障'
export const MedicalCoverage = '病気やケガの医療保障'
export const PensionSavings = '年金や貯蓄の相談'
export const CorporateInsurance = '法人の保険'
export const Remarks = '備考・ご希望 [任意]'
export const RemarksPlaceholder = 'ご連絡に都合のつかない時間帯やご相談に関する希望についてご記入ください。'
export const RemarksText = '全角500文字以内。担当者のご指定はできませんのでご了承ください。'
export const SubmitButton = 'この内容で申し込む'

export const paragraphText1 = '当サイトはお客さまの個人情報を安全に送受信するために128bit版SSL（暗号化通信）を使用しております。'
export const paragraphTextLink = '詳細はこちらをご覧ください。'
export const remarkSign = '※'
export const paragraphText2 = 'ご入力いただきました個人情報は、当社の商品を取扱う営業職員または代理店によるコンサルティング、および当社の商品・サービスのご案内'
export const paragraphText3 = 'に使用します。'
export const paragraphText4 = '上記にご同意いただける場合は、情報をご送信ください。なお、確認のため、当社から連絡をさせていただく場合がございますので、あらかじめ'
export const paragraphText5 = 'ご了承ください。'
export const faceTofacelabelText = '希望面談形式'
export const faceToface = '対面形式'
export const onlineText = 'オンライン形式'
// --------errorMessageText----------- //
export const headErrorMssg = '入力内容に不備があります。'
export const kanjiLastNameMssg = '★15文字以下です'
export const kanaLastNameMssg = '★全角カタカナのみです'
export const phoneNoInvalidCharaterMssg = '★半角数字のみです'
export const emailInvalidCharaterMssg = '★入力形式が間違っている部分があります'
export const postalInvalidCharaterMssg = '★半角数字のみです'
